import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/customer-redux";

import { WritableReferralForm as ReferralForm } from "@teamprevent/common/questionnaires/components/referralForm/WritableReferralForm";
import { loadHrRepresentatives, loadOrgStructure } from "@teamprevent/common/questionnaires/components/referralForm/actions";

import { ApplicationState } from "../../applicationState";
import { loadReferralConfig } from "../../questionnaireConfig/actions";

export const WritableReferralForm: React.FunctionComponent = () => {

    const ohCaseId = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(loadHrRepresentatives());
        dispatch(loadReferralConfig());
        dispatch(loadOrgStructure());
    }, [dispatch]);

    const loadOrganisationStructure = React.useCallback((parentOrgStructureLevelId: string) => {
        dispatch(loadOrgStructure(parentOrgStructureLevelId));
    }, [dispatch]);

    return (
        <ReferralForm
            loadOrgStructure={loadOrganisationStructure}
            useAutoSave={true}
            referAgainOhCaseId={ohCaseId}
            documentBaseApi={"/api/referral"}
        />
    );
};
